import {Component, OnInit, Input} from '@angular/core';
import {Router} from '@angular/router';
import {WordpressPostService} from '../../../service/wordpress-post.service';
import {GlobalAppService} from '../../../../core/commons/global-app.service';
import {WordpressPost} from '../../../domain/wordpress-post';
import {Observable} from 'rxjs/Observable';
import {platform} from 'os';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Component({
    selector: 'wordpress-post-list',
    templateUrl: './wordpress-post-list.component.html',
    styleUrls: ['./wordpress-post-list.component.css'],
    providers: [WordpressPostService]
})
export class WordpressPostListComponent implements OnInit {

    @Input('placeholder') placeholder: boolean = true;

    @Input() posts: WordpressPost[] = [];

    constructor(private wordpressPostService: WordpressPostService,
                private router: Router,
                private messageService: GlobalAppService) {
    }

    ngOnInit() {}

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/news/wordpress-post-list/wordpress-post-list.component.ts